/* src/students/cards/StudentListCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { filter, isEmpty, toUpper } from 'lodash';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Chip, TextField } from '@material-ui/core';
import styles from './styles';

import { HeaderTable } from '../../../../app/components';
import CustomSelect from '../../../../app/components/Select';
import { loadTexts } from '../../../../config/texts';

import { fetchStudents, fetchStudent, clearSelectedStudent } from '../../actions';
import {
  getStudents,
  fetchStudentsState,
} from '../../selectors';

// const ISNUMERIC = [false, false, true, true, true, true];

const TEXT_KEY = 'students';

class StudentListCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBy: '',
      searchByValue: '',
      filterByArray: [],
      filteredData: props.students,
      texts: loadTexts(TEXT_KEY, props.locale),
      totalArray: [],
      dateArray: [],
    };
    this.changeFilterStatus = this.changeFilterStatus.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this._onFetchStudents = this._onFetchStudents.bind(this);
    this._onSelectStudent = this._onSelectStudent.bind(this);
    this._filter = this._filter.bind(this);
  }

  componentDidMount() {
    // const { listRange: { start, end }, students } = this.props;
    // if (_.isEmpty(students)) this._onFetchStudents(start, end);
    const { texts: { select_field } } = this.state;
    this.setState({
      totalArray: [
        select_field.total,
        select_field.current
      ],
      dateArray: [
        select_field.all,
        select_field.day,
        select_field.week,
        select_field.semester,
        select_field.filter
      ]
    })
    this._onFetchStudents();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedUniversity !== this.props.selectedUniversity
      || nextProps.selectedOrganization !== this.props.selectedOrganization
    ) {
      this.props.fetchStudents({ studentSearchInput: {
        _universities: [nextProps.selectedUniversity],
        _organizations: [nextProps.selectedOrganization],
      } }).then(() => {
        this._filter();
        this.props.clearSelectedStudent();
      });
    }
  }

  _filter() {
    const { filterByArray } = this.state;
    if (isEmpty(filterByArray)) {
      this.setState({ filteredData: this.props.students });
    } else {
      filterByArray.forEach(f => {
        switch (f.searchBy) {
          case 'Name':
            this.setState({
              filteredData: filter(
                this.props.students,
                t => toUpper(t.name).includes(toUpper(f.value))
              ),
            });
            break;
          default:
            return null;
        }
      });
    }
  }

  _onFetchStudents() {
    const { selectedUniversity, selectedOrganization } = this.props;
    this.props.fetchStudents({ studentSearchInput: {
      _universities: [selectedUniversity],
      _organizations: [selectedOrganization],
    } }).then(() => {
      this._filter();
    });
  }

  changeFilterStatus(status) {
    this.setState({ searchBy: status });
  }

  handleDelete(chip) {
    const { filterByArray } = this.state;
    const chipData = [...filterByArray];
    const chipToDelete = chipData.indexOf(chip);

    chipData.splice(chipToDelete, 1);
    this.setState({ filterByArray: chipData });
  }

  keyBoardPressed(ev) {
    const { searchBy, searchByValue, filterByArray } = this.state;

    if (ev.key === 'Enter' && searchByValue !== '' && searchBy !== '') {
      const temp = filterByArray;
      temp.push({ searchBy, value: ev.target.value });
      this.setState({ searchByValue: '', filterByArray: temp }, () => this._filter());
    }
  }

  async _onSelectStudent({ _id }) {
    await this.props.fetchStudent({ student: _id });
    console.log(this.props);
    this.props.history.push('/home/students/student');
  }

  renderChips() {
    const { classes } = this.props;
    const { filterByArray } = this.state;
    return filterByArray.map((c, index) => (
      <Chip
        key={index}
        label={`${c.searchBy}: ${c.value}`}
        onDelete={() => this.handleDelete(c)}
        className={classes.chip}
      />
    ));
  }

  renderFilter() {
    const { classes } = this.props;
    const { searchBy, searchByValue, texts } = this.state;

    return (
      <Grid container justify="flex-start" alignItems="flex-end" className={classes.gridContainer}>
        <TextField
          id="search"
          label={`${searchBy} ${texts.select_field.filter}`}
          value={searchByValue}
          type="search"
          className={classes.textField}
          margin="normal"
          onChange={event => { this.setState({ searchByValue: event.target.value }); }}
          onKeyPress={ev => this.keyBoardPressed(ev)}
        />
        <CustomSelect dataArray={[texts.select_field.name]} onValueChange={this.changeFilterStatus} withDefault />
        {this.renderChips()}
      </Grid>
    );
  }

  renderSearch() {
    return (
      <Grid container direction="row">
        <CustomSelect dataArray={this.state.totalArray} withDefault />
        <CustomSelect dataArray={this.state.dateArray} withDefault />
      </Grid>
    );
  }

  render() {
    const {
      classes,
      // listRange: { start, end, count },
      fetchState: { loading },
    } = this.props;
    const { filteredData } = this.state;

    return (
      <Paper className={classes.card}>
        {this.renderFilter()}
        {/* this.renderSearch() */}
        <HeaderTable
          label="students"
          data={filteredData}
          // paging
          // start={start}
          // end={end}
          // count={count}
          // onNext={this._onNextPage}
          // onPrev={this._onPrevPage}
          loading={loading}
          hover
          onRowClick={this._onSelectStudent}
        />
      </Paper>
    );
  }
}

StudentListCard.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchStudents: PropTypes.func.isRequired,
  fetchStudent: PropTypes.func.isRequired,
  fetchState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
  students: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  students: getStudents(state),
  fetchState: fetchStudentsState(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  fetchStudents: params => dispatch(fetchStudents(params)()),
  fetchStudent: params => dispatch(fetchStudent(params)()),
  clearSelectedStudent: () => dispatch(clearSelectedStudent()),
});

export default compose(
  withRouter,
  withStyles(styles, { name: 'StudentListCard' }),
  connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })
)(StudentListCard);



// WEBPACK FOOTER //
// ./src/modules/students/cards/StudentListCard/index.js